import React, { useEffect, useState } from "react";
import "styles/DailyReport.scss";
import { dailyReport } from "api/dailyReport";
import { useQuery } from "react-query";
import { momentJapan } from "utils/datetime";
import { IDailyReportResponse } from "types/dailyReport";
import { formatMoney } from "utils/format";
import moment from "moment";
import { Dropdown, MenuProps } from "antd";

import iconMenu from "../../assets/images/icon/menu.svg";
import { logout } from "api/axios";

const END_HOUR_TIME = 29;

const DailyReport: React.FC = () => {
  const today =
    momentJapan().hour() < END_HOUR_TIME % 24
      ? momentJapan().subtract(1, "days")
      : momentJapan();
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalPaymentCash, setTotalPaymentCash] = useState(0);

  const handleSignOut = () => {
    logout();
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <button className="base-button" onClick={handleSignOut}>
          <span className="option">サインアウト</span>
        </button>
      ),
      key: "0",
    },
  ];

  const { data: dailyReportData } = useQuery<IDailyReportResponse>(
    ["DailyReport", today.format("YYYY-MM-DD")],
    () => {
      return dailyReport({
        date: today.format("YYYY-MM-DD"),
      });
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (dailyReportData) {
      const total = dailyReportData.data.totalRevenue || 0;
      const totalCash = dailyReportData.data.totalPaymentCash || 0;
      setTotalPaymentCash(totalCash);
      setTotalRevenue(total);
    }
  }, [dailyReportData]);
  // Calculate XX = total cash - total revenue after equipment cost deduction
  const calculateDifference = () => {
    return totalPaymentCash - totalRevenue;
  };

  // Create notification message
  const getNotificationMessage = () => {
    const difference = calculateDifference();

    if (difference < 0) {
      return `${Math.abs(difference).toLocaleString()}円不足していますので、お手数をお掛けしますがスタッフへご連絡ください！`;
    } else {
      return `${difference.toLocaleString()}円封筒に入れて投函お願いします！`;
    }
  };

  return (
    <div className="daily-report-container">
      <Dropdown menu={{ items }} trigger={["click"]} className="dropdown-menu">
        <button className="base-button">
          <img src={iconMenu} width={44} height={44} alt="menu" />
        </button>
      </Dropdown>
      <h2>給料明細（{today.format("YYYY/MM/DD")}）</h2>
      {dailyReportData?.data.eventImage && (
        <img
          className="eventImage"
          src={dailyReportData.data.eventImage.image}
          alt="event"
        />
      )}

      <div className="revenue-container">
        <h3>
          報酬合計<span>（{today.format("MM")}月{today.format("DD")}日）</span>
        </h3>
        <div className="box box-total">
          <div className="total">
            合計&nbsp;
            <span>{formatMoney(totalRevenue, "￥")}</span>
          </div>
          <div className="total-sub">
            現金売上 - 報酬額 =&nbsp;
            <span>{formatMoney(totalPaymentCash - totalRevenue, "￥")}</span>
          </div>
         
          <div className="total-sub">{getNotificationMessage()}</div>
        </div>
        {dailyReportData?.data.orders.length > 0 && <h3>個別報酬明細</h3>}
        {dailyReportData?.data.orders.map((order) => (
          <div key={order.id} className="box">
            <div className="line header">
              <span className="time">
                {moment(order.date_start).format("HH:mm") +
                  " ~ " +
                  moment(order.date_end).format("HH:mm")}
              </span>
              <span className="amount">
                {formatMoney(
                  Number(order.therapist_amount) - Number(order.equipment_cost),
                )}
              </span>
            </div>
            <div className="line">
              <div className="item">
                <span>{order.course.name}{order.payment_method && `(${order.payment_method.name})`}</span>
                {/* <span className="amount"></span>
                  {formatMoney(order.course_therapist_amount)}
                </span> */}
              </div>
              <span className="amount">
                {formatMoney(order.course_therapist_amount)}
              </span>
            </div>
            {order.options.map((orderOption) => (
              <div key={orderOption.id} className="line">
                <div className="item">
                  <span>{orderOption.option.name}{orderOption.payment_method && `(${orderOption.payment_method.name})`}</span>
                  {/* <span className="amount">
                    {formatMoney(orderOption.therapist_amount)}
                  </span> */}
                </div>
                <span className="amount">
                  {formatMoney(orderOption.therapist_amount)}
                </span>
              </div>
            ))}
            {order.extensions.map((orderExtension) => (
              <div key={orderExtension.id} className="line">
                <div className="item">
                  <span>{orderExtension.extension.name}{orderExtension.payment_method && `(${orderExtension.payment_method.name})`}</span>
                  {/* <span className="amount">
                    {formatMoney(orderExtension.therapist_amount)}
                  </span> */}
                </div>
                <span className="amount">
                  {formatMoney(orderExtension.therapist_amount)}
                </span>
              </div>
            ))}
            {order.nomination && order.nomination_therapist_amount && (
              <div className="line">
                <div className="item">
                  <span>{order.nomination.name}{order.payment_method && `(${order.payment_method.name})`}</span>
                  {/* <span className="amount">
                    {formatMoney(order.nomination_therapist_amount)}
                  </span> */}
                </div>
                <span className="amount">
                  {formatMoney(order.nomination_therapist_amount)}
                </span>
              </div>
            )}
            {Number(order.equipment_cost) > 0 && (
              <div className="line">
                <div className="item">
                  <span>備品代</span>
                  {/* <span className="amount amount-red">
                    {formatMoney(order.equipment_cost)}
                  </span> */}
                </div>
                <span className="amount amount-red">
                  - {formatMoney(order.equipment_cost)}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailyReport;
